import type { AnswerType } from '~/model/AnswerType';
import type { AnswerUserType } from '~/model/AnswerUserType';
import type { QuestionReconstructedType } from '~/model/QuestionType';
import { apiTypes } from '~/const/api';

const {
  SELECT,
  RADIO,
  CHOICES_JAR,
  CONDITIONAL,
  CHECK,
  PICTURE,
  FILE,
  RANKING,
  RANKING_PICTURE,
  RANKING_SCALE,
} = apiTypes;

export function updateAllAnswers(
  answers: AnswerType[],
  answerUser: AnswerUserType,
  questionsCollection: QuestionReconstructedType[],
) {
  let updatedAnswers: any = { ...answerUser };
  answers.forEach((answer: AnswerType) => {
    const questionId = answer.question;
    const valueText = answer.value_text;
    const valueFloat = answer.value_float;
    const valueInt = answer.value_int;
    const valueDate = answer.value_date && new Date(answer.value_date);
    const valueHour
      = (answer.value_hour || answer.value_hour === 0)
        && (answer.value_minute || answer.value_minute === 0)
        && `${answer.value_hour}:${answer.value_minute}`;
    const valueMedia = answer.media?.['@id'];
    const valueMediaUrl = answer.media?.content_url;
    const valueRanking = answer.ranking;
    const valueRankingScale = answer.ranking_scale;
    const type = questionsCollection?.find(
      q => q['@id'] === answer.question,
    )?.type;
    const subQuestionId = answer.sub_question;

    let value: any;
    if (type === RADIO || type === CHECK || type === CHOICES_JAR) {
      if (answer.choices?.length > 0)
        value = answer.choices;
    } else if (valueText) {
      value = answer.value_text;
    } else if (valueFloat || valueFloat === 0) {
      value = valueFloat;
    } else if (valueInt || valueInt === 0) {
      value = valueInt;
    } else if (valueDate) {
      value = valueDate;
    } else if (valueHour) {
      value = valueHour;
    } else if (type === PICTURE || type === FILE) {
      value = valueMedia;
    } else if (type === RANKING) {
      value = valueRanking;
    } else if (type === RANKING_SCALE) {
      value = valueRankingScale;
    } else if (answer.choices?.length > 0) {
      value = answer.choices;
    }

    if (subQuestionId) {
      updatedAnswers = {
        ...updatedAnswers,
        [questionId]: {
          ...updatedAnswers[questionId],
          answer_choices: {
            ...(updatedAnswers[questionId]?.answer_choices),
            [subQuestionId]: value,
          },
          type,
        },
      };
    } else if (
      type === RADIO
      || type === CHECK
      || type === CONDITIONAL
      || type === SELECT
      || type === CHOICES_JAR
    ) {
      updatedAnswers = {
        ...updatedAnswers,
        [questionId]: {
          answer_choices: value,
          type,
          value_text: answer.value_text,
        },
      };
    } else if (type === PICTURE || type === FILE) {
      updatedAnswers = {
        ...updatedAnswers,
        [questionId]: {
          media: valueMediaUrl,
          type,
          value,
        },
      };
    } else if (type === RANKING) {
      updatedAnswers = {
        ...updatedAnswers,
        [questionId]: {
          answer_choices: {
            ranking: valueRanking,
          },
          type,
        },
      };
    } else if (type === RANKING_PICTURE) {
      updatedAnswers = {
        ...updatedAnswers,
        [questionId]: {
          answer_choices: {
            ranking: answer.ranking,
            choices: answer.choices,
          },
          type,
        },
      };
    } else if (type === RANKING_SCALE) {
      updatedAnswers = {
        ...updatedAnswers,
        [questionId]: {
          answer_choices: {
            ranking_scale: valueRankingScale,
          },
          type,
        },
      };
    } else {
      updatedAnswers = {
        ...updatedAnswers,
        [questionId]: {
          type,
          value,
        },
      };
    }
  });

  return { answerUser: updatedAnswers };
}
